import {
  apiClient,
  type TruckClassImportJobExEntity,
  type PageEntity
} from '@/libs/api'
import { type TruckClassImportJobsRequestQuery } from '@/libs/api/types'

export type FetchTruckClassImportJobsQuery = {
  tenantKey: string
  query: TruckClassImportJobsRequestQuery
}

export type FetchTruckClassImportJobsResponse = {
  data: TruckClassImportJobExEntity[]
  pagination: PageEntity | null
}

export const fetchTruckClassImportJobs = async (
  { tenantKey, query }: FetchTruckClassImportJobsQuery,
  signal?: AbortSignal
): Promise<FetchTruckClassImportJobsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .truck_class_import_jobs.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
